/**
* Unir un objeto por id item.id a una lista de objetos con id.
* @param {Array} list - lista a la que se actualizara.
* @param {Object} item - item que se añadira comparado por id.
* @returns {Array} - Lista de la union del item.
* */
export const addOrUpdateList = (list, item) => {
    return list.map(_item => {
        if (_item.id === item.id) {
            return item;
        }
        return _item;
    });
}
/**
* Unir un objeto por id item.id a una lista de objetos con id.
* @param {Array} list - lista a la que se actualizara.
* @param {Object} item - item que se añadira comparado por id.
* @returns {Array} - Lista de la union del item.
* */
export const updateListById = (list, item) => {
    return list.map(_item => {
        if (_item.id === item.id) {
            return item;
        }
        return _item;
    });
}
/**
 * Crea objeto con choices en pares de una lista
 * @param {Array} list - Lista a convertir en objetos con [(key, value)]
 * @returns {Object} result - Objeto resultado de la lista
 */
export const arrayToObjectByPairs = (list) => {
    let result = {}, i;
    for (i = 0; i < list.length; i++) {
        //       key             value
        result[list[i][0]] = list[i][1];
    }
    return result;
}